import { Link } from 'react-router-dom';

export default function AccessSection() {
  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div>
              <span className="text-cyan-500 text-sm font-semibold tracking-wider uppercase">Access</span>
            </div>
            
            <h2 className="text-3xl font-bold text-gray-900">
              アクセス
            </h2>

            <div className="space-y-8">
              <div className="bg-gray-50 rounded-2xl p-6 space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-train-line text-2xl text-cyan-500 flex-shrink-0 mt-1"></i>
                  <div className="flex-1">
                    <p className="font-bold text-lg text-gray-900 mb-3">JR横須賀線「逗子駅」より徒歩約11分</p>
                    <ol className="space-y-2 text-gray-700">
                      <li className="flex gap-2">
                        <span className="font-semibold text-cyan-600 flex-shrink-0">1.</span>
                        <span>東口を出て駅前ロータリーを右手に進む</span>
                      </li>
                      <li className="flex gap-2">
                        <span className="font-semibold text-cyan-600 flex-shrink-0">2.</span>
                        <span>国道134号線(逗子海岸通り)を海の方向へ直進</span>
                      </li>
                      <li className="flex gap-2">
                        <span className="font-semibold text-cyan-600 flex-shrink-0">3.</span>
                        <span>約850m直進すると左手に「ミハルアート逗子海岸」</span>
                      </li>
                      <li className="flex gap-2">
                        <span className="font-semibold text-cyan-600 flex-shrink-0">4.</span>
                        <span>建物2階の202号室</span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-2xl p-6 space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-train-line text-2xl text-cyan-500 flex-shrink-0 mt-1"></i>
                  <div className="flex-1">
                    <p className="font-bold text-lg text-gray-900 mb-3">京急逗子線「逗子・葉山駅」より徒歩約3分</p>
                    <ol className="space-y-2 text-gray-700">
                      <li className="flex gap-2">
                        <span className="font-semibold text-cyan-600 flex-shrink-0">1.</span>
                        <span>改札を出てJR逗子駅方面へ向かう</span>
                      </li>
                      <li className="flex gap-2">
                        <span className="font-semibold text-cyan-600 flex-shrink-0">2.</span>
                        <span>JR逗子駅東口に到着後、国道134号線を海の方向へ</span>
                      </li>
                      <li className="flex gap-2">
                        <span className="font-semibold text-cyan-600 flex-shrink-0">3.</span>
                        <span>約200m直進すると左手に「ミハルアート逗子海岸」</span>
                      </li>
                      <li className="flex gap-2">
                        <span className="font-semibold text-cyan-600 flex-shrink-0">4.</span>
                        <span>建物2階の202号室</span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-cyan-50 rounded-2xl p-6">
                <i className="ri-map-pin-line text-2xl text-cyan-500 flex-shrink-0"></i>
                <div>
                  <p className="font-medium text-lg text-gray-900">〒249-0006</p>
                  <p className="leading-relaxed text-gray-700">
                    神奈川県逗子市逗子5丁目11-7<br />
                    ミハルアート逗子海岸202
                  </p>
                </div>
              </div>
            </div>

            <Link
              to="/company"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white text-cyan-600 border-2 border-cyan-500 rounded-full font-medium hover:bg-cyan-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              詳しいアクセス情報
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="space-y-6">
            <div className="h-[400px] rounded-3xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3256.4577214503224!2d139.57633632714894!3d35.29460660111327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601846ee335c25fb%3A0xc8343efd056aad01!2z44CSMjQ5LTAwMDYg56We5aWI5bed55yM6YCX5a2Q5biC6YCX5a2Q77yV5LiB55uu77yR77yR4oiS77yX!5e0!3m2!1sja!2sjp!4v1768455231614!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="まごころヘルパーの地図"
              ></iframe>
            </div>

            <div className="h-[400px] rounded-3xl overflow-hidden shadow-lg">
              <img
                src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/72d2aaebb48723b63609b0fc02eb2e45.jpeg"
                alt="ミハルアート逗子海岸 建物外観"
                className="w-full h-full object-cover"
                style={{ objectPosition: 'center 35%' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
